import { render, staticRenderFns } from "./NotVotingTable.vue?vue&type=template&id=0c7e41d6&"
import script from "./NotVotingTable.vue?vue&type=script&lang=js&"
export * from "./NotVotingTable.vue?vue&type=script&lang=js&"
import style0 from "./NotVotingTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports